///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { API, CancelToken } from "../api/axios";

let cancelGetEmployeesToken;

export const getBidTeam = bidId => {
  return API.get("api/v1.0/persons/bid-team", {
    params: {
      bidId
    }
  });
};

export const getEmployees = searchTerm => {
  cancelGetEmployeesToken && cancelGetEmployeesToken("Cancelled By User");
  return API.get("api/v1.0/persons/employee-search", {
    params: {
      searchTerm
    },
    cancelToken: new CancelToken(function executor(cancelToken) {
      cancelGetEmployeesToken = cancelToken;
    })
  });
};

export const putTeamContact = teamContactUpdateRequest =>
  API.put("api/v1.0/persons/bid-team", teamContactUpdateRequest);

export const postBidSubscriber = bidSubscriberRequest =>
  API.post("api/v1.0/persons/bid-subscriber", bidSubscriberRequest);

export const deleteBidSubscriber = bidSubscriberRequest => {
  return API.delete("api/v1.0/persons/bid-subscriber", {
    data: bidSubscriberRequest
  });
};
